import { render, staticRenderFns } from "./DeliveryTypeResponsibilitiesComponent.vue?vue&type=template&id=4b886ef4"
import script from "./DeliveryTypeResponsibilitiesComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryTypeResponsibilitiesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports